/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:24/06/2021
 @Time:15:48
 **/
//partie commune pour tous les pages de front-office
import "./navigation";
import "node-waves/dist/waves";
import googleRecaptchaService from "./google-recaptcha";
window.googleRecaptchaService=googleRecaptchaService;
import "./layout"